import { useNavigationState, useRoute } from '@react-navigation/native';

/**
 * Whether this screen is the first route of its own stack, or was pushed on top of another one.
 * Checks the screen's own position, so it stays stable while other screens sit on top of it.
 */
export const useIsFirstScreenInStack = () => {
    const { key: routeKey } = useRoute();

    return useNavigationState(state => state.routes[0]?.key === routeKey);
};
